<template>
    <div class="main">
        <c-panel title="MATERIAIS DA TURMA" titleIcon="fas fa-folder-open">
            <el-row :gutter="10" class="u-mb-10">
                <el-col :xs="24" :sm="6">
                    <el-input v-model="filtro.busca" placeholder="Buscar título" @keyup.enter.native="load" clearable></el-input>
                </el-col>
                <el-col :xs="24" :sm="6">
                    <el-select v-model="filtro.tipo" placeholder="Tipo" clearable @change="load" style="width:100%;">
                        <el-option :value="1" label="ARQUIVO"></el-option>
                        <el-option :value="2" label="VÍDEO"></el-option>
                        <el-option :value="3" label="LINK"></el-option>
                        <el-option :value="4" label="AVISO/TEXTO"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" class="u-text-right">
                    <el-button @click="load" icon="el-icon-search">FILTRAR</el-button>
                    <router-link class="u-ml-10" to="/admin/material-turma/cadastro"><el-button type="primary" icon="el-icon-plus">NOVO MATERIAL</el-button></router-link>
                </el-col>
            </el-row>

            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width:70px;">Cod</th>
                        <th>Título</th>
                        <th style="width:110px;">Tipo</th>
                        <th>Turma</th>
                        <th style="width:130px;">Liberação</th>
                        <th style="width:120px;">Limite</th>
                        <th style="width:90px;">Retornos</th>
                        <th style="width:200px;" class="u-text-center">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="m in items" :key="m.id">
                        <td>{{ m.id }}</td>
                        <td>{{ m.titulo }}</td>
                        <td><el-tag size="mini" :type="tagTipo(m.tipo)">{{ rotuloTipo(m.tipo) }}</el-tag></td>
                        <td>{{ m.turma ? m.turma.nome : '—' }}</td>
                        <td>{{ m.data_liberacao | formatarDt }}</td>
                        <td>
                            <span v-if="m.data_limite">{{ m.data_limite | formatarDt }}</span>
                            <span v-else style="color:#909399;">sem limite</span>
                        </td>
                        <td>
                            <span v-if="m.requer_retorno">
                                <el-button size="mini" plain @click="verRetornos(m)">VER</el-button>
                            </span>
                            <span v-else style="color:#909399;">—</span>
                        </td>
                        <td class="u-text-center">
                            <router-link :to="'/admin/material-turma/edit/' + m.id">
                                <el-button size="mini" type="info" icon="el-icon-edit" plain></el-button>
                            </router-link>
                            <el-button class="u-ml-10" size="mini" type="danger" icon="el-icon-delete" plain @click="excluir(m.id)"></el-button>
                        </td>
                    </tr>
                    <tr v-if="!items.length">
                        <td colspan="8" class="u-text-center" style="padding: 20px; color: #909399;">Nenhum material publicado.</td>
                    </tr>
                </tbody>
            </table>

            <el-dialog title="Devoluções dos alunos" :visible.sync="modalRetornosVisivel" width="700px">
                <p v-if="materialAtivo"><strong>{{ materialAtivo.titulo }}</strong></p>
                <table class="table">
                    <thead><tr><th>Aluno</th><th>Enviado em</th><th>Arquivo</th><th>Comentário</th></tr></thead>
                    <tbody>
                        <tr v-for="r in retornos" :key="r.id">
                            <td>{{ r.aluno ? r.aluno.nome : ('Aluno #' + r.aluno_id) }}</td>
                            <td>{{ r.data_envio | formatarDt }}</td>
                            <td>
                                <a v-if="r.caminho" :href="r.caminho" target="_blank" @click="registrarDownloadRetorno(r)">{{ r.caminho_nome || 'Abrir' }}</a>
                                <span v-else style="color:#909399;">—</span>
                            </td>
                            <td>{{ r.comentario || '—' }}</td>
                        </tr>
                        <tr v-if="!retornos.length"><td colspan="4" class="u-text-center" style="color:#909399; padding:10pt;">Nenhuma devolução ainda.</td></tr>
                    </tbody>
                </table>
            </el-dialog>
        </c-panel>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    filters: { formatarDt (v) { return v ? moment(v).format('DD/MM/YYYY HH:mm') : '' } },
    data () {
        return {
            items: [], filtro: { busca: '', tipo: null },
            modalRetornosVisivel: false, materialAtivo: null, retornos: []
        }
    },
    mounted () { this.load() },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        rotuloTipo (t) { return { 1: 'Arquivo', 2: 'Vídeo', 3: 'Link', 4: 'Aviso' }[t] || '?' },
        tagTipo (t) { return { 1: 'info', 2: 'success', 3: 'warning', 4: '' }[t] || '' },

        load () {
            this.$axios.post(`${this.baseUrl()}/api/material-turma/getAllPaginate`,
                { instituicao_id: this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null, ...this.filtro },
                this.$store.getters.getHeaderAuth
            ).then(r => { this.items = (r.data && r.data.data) ? r.data.data : (r.data || []) })
              .catch(e => this.$store.commit('throwException', e))
        },
        excluir (id) {
            this.$confirm('Excluir material?', 'Confirmar', { type: 'warning' }).then(() => {
                this.$axios.delete(`${this.baseUrl()}/api/material-turma/delete/${id}`, this.$store.getters.getHeaderAuth).then(() => this.load())
            }).catch(() => {})
        },
        verRetornos (m) {
            this.materialAtivo = m
            this.modalRetornosVisivel = true
            this.$axios.get(`${this.baseUrl()}/api/material-turma-retorno/getByMaterial/${m.id}`, this.$store.getters.getHeaderAuth)
                .then(r => { this.retornos = r.data || [] })
        },
        // Contabiliza o download da devolução do aluno pelo coord/prof (best-effort).
        registrarDownloadRetorno (r) {
            if (!this.materialAtivo) return
            this.$axios.post(`${this.baseUrl()}/api/material-turma/registrarDownload`,
                { material_turma_id: this.materialAtivo.id, material_turma_retorno_id: r.id },
                this.$store.getters.getHeaderAuth
            ).catch(() => {})
        }
    }
}
</script>
